const DateTimeHelper = {
  pad: (n: number): string => {
    return n.toString().padStart(2, '0');
  },

  getFormatDate: (date: Date): string => {
    return `${date.getFullYear()}-${DateTimeHelper.pad(date.getMonth() + 1)}-${DateTimeHelper.pad(date.getDate())}`;
  },

  getFormatTime: (date: Date): string => {
    return `${DateTimeHelper.pad(date.getHours())}:${DateTimeHelper.pad(date.getMinutes())}`;
  },
};

export default DateTimeHelper;
